import React, { useMemo } from 'react';
import moment from 'moment';
import { rrulestr } from 'rrule';
import { generateRuleString } from '../../../components/Scheduler/utils';
import GeneralFormItem from '../../../components/GeneralFormItem';

interface IScheduleRecurrence {
  cron: string | null;
  timezone: string | null;
}

export default ({ cron, timezone }: IScheduleRecurrence) => {
  const rruleText = useMemo(() => {
    if (!cron) {
      return '';
    }

    const rrule = rrulestr(cron);

    return generateRuleString(rrule);
  }, [cron]);

  if (!rruleText) {
    return null;
  }

  const timezoneAbbr = timezone ? moment().tz(timezone).zoneAbbr() : '';

  const content = `${rruleText} ${timezoneAbbr}`;

  return <GeneralFormItem label={content} placement="bottom-end" />;
};
